module.exports = __webpack_public_path__ + "media/assets/images/blog/CloudApplications-images-2b4c0ff685873cae289a0a3ebbfd8070.jpg";